<template>
  <ListItem :to="{ name: 'user', params: { id: user.id } }">
    <div class="basis-[25%]">
      <UserListItemTitle>
        {{ t('name') }}
      </UserListItemTitle>
      <p>{{ user.firstName }} {{ user.lastName }}</p>
    </div>
    <div class="basis-[31%]">
      <UserListItemTitle>
        {{ t('email') }}
      </UserListItemTitle>
      <p>{{ user.email }}</p>
    </div>
    <div class="basis-[30%]">
      <UserListItemTitle>
        {{ t('role') }}
      </UserListItemTitle>
      <p>{{ userRoleString }}</p>
    </div>
    <div class="basis-[14%] text-right">
      <UserListItemTitle>
        {{ t('createdAt') }}
      </UserListItemTitle>
      <p>{{ formattedCreatedDate }}</p>
    </div>
  </ListItem>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import UserListItemTitle from './UserListItemTitle.vue';
import type { User } from '@/entities/auth/user.entity';
import { useFormattedDate } from '@/hooks/use-formatted-date';
import { getDateFormat } from '@/hooks/use-date-format';
import { computed } from 'vue';
import { UserRole } from '@/entities/auth/user-role.enum';
import ListItem from '@/components/ListItem.vue';
import { getLocalizedField } from '@/utils/get-localized-field';

const props = defineProps<{
  user: User;
}>();

const { t, locale } = useI18n();

const userRoleString = computed(() => {
  return ![UserRole.AGENCY, UserRole.COMPANY].includes(props.user.role)
    ? t(`userRoles.${props.user.role}`)
    : getLocalizedField(props.user.partnerSubType?.name ?? { de: '-', en: '-' }, locale.value);
});

const formattedCreatedDate = useFormattedDate(props.user.createdDate, getDateFormat());
</script>

<i18n lang="json">
{
  "en": {
    "name": "Name",
    "email": "Email",
    "role": "Role",
    "createdAt": "Created at"
  },
  "de": {
    "name": "Name",
    "email": "Email",
    "role": "Rolle",
    "createdAt": "Erstellt am"
  },
  "es": {
    "name": "Nombre",
    "email": "Correo electrónico",
    "role": "Rol",
    "createdAt": "Creado el"
  }
}
</i18n>
